import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  Observable,
  debounceTime,
  delay,
  distinctUntilChanged,
  map,
  of,
} from 'rxjs';
import { rotateAnimation, expandCollapse } from 'src/app/shared/helpers/animation';
import {
  convertDMtoDD,
  convertLatitudeDDtoDM,
  convertLongitudeDDtoDM,
} from 'src/app/shared/helpers/dmToDd';
// import { PwSubmitPopupComponent } from '../pw-submit-popup/pw-submit-popup.component';
import { PortWeatherService } from 'src/app/shared/service/port-weather/port-weather.service';
// import { PwThanksPageComponent } from '../pw-thanks-page/pw-thanks-page.component';
import { LoginService } from 'src/app/shared/service/login/login.service';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-pw-home',
  templateUrl: './pw-home.component.html',
  styleUrls: ['./pw-home.component.scss'],
  animations: [rotateAnimation, expandCollapse]
})
export class PwHomeComponent {
  portForm: FormGroup;
  formSubmitted: boolean = false;
  toggle: boolean = false;
  days = [0, 1, 2, 3, 4, 5, 6, 7];
  splitHours = [3, 4, 6, 8];
  laDirection = ['N', 'S'];
  loDirection = ['E', 'W'];
  checked = false;
  todayDate = new Date();
  button: boolean = true;
  portNameSelected: boolean = false;

  required: boolean = true;

  filteredPortNameSuggestions: any[] = [];
  total: any;
  allPortData: any;
  isLoadingPorts: boolean = true;
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    public dialog: MatDialog,
    private portWeather: PortWeatherService,
    private loginService: LoginService,
    private requestFormService: RequestFormService
  ) {
    this.portForm = this.fb.group({
      port_lat: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/),
        ],
      ],
      port_lng: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
          ),
        ],
      ],
      days: ['5'],
      hours_split: [6],
      port_name: ['', this.nameValidators('port_name')],
      ship_name: ['', Validators.required],
      atSea: [''],
      la_Degree: ['', this.getValidators('la_Degree')],
      la_Min: ['', this.getValidators('la_Min')],
      la_Dir: ['', this.getValidators('la_Dir')],
      lo_Degree: ['', this.getValidators('lo_Degree')],
      lo_Min: ['', this.getValidators('lo_Min')],
      lo_Dir: ['', this.getValidators('lo_Dir')],
      start_date: [''],
    });
  }
  ngOnInit(): void {
    this.isLoadingPorts = true;
    this.portWeather.getPortDetails().subscribe((response: any) => {
      this.allPortData = response.data;
      this.isLoadingPorts = false;
    });
    this.portForm
      .get('port_name')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: string) => {
        this.filterSuggestions(value);
      });
    // Direction fields always enabled — coordinate section is always visible
    this.portForm.get('la_Dir')?.enable();
    this.portForm.get('lo_Dir')?.enable();
  }
  validateTotalDays(): Observable<number> {
    const selectedDate = this.portForm.get('start_date')?.value;
    const startDate = selectedDate ? new Date(selectedDate) : null;
    const selectedDays = this.portForm.get('days')?.value;

    if (startDate && selectedDays) {
      const currentDate = new Date();

      const daysDiff = Math.ceil(
        (startDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24)
      );
      const total = Number(daysDiff) + Number(selectedDays);
      return of(total);
    }

    return of(0);
  }

  getValidators(controlName: string): any[] {
    if (this.toggle) {
      return [Validators.required];
    }
    return [];
  }
  nameValidators(controlName: string): any[] {
    if (controlName === 'port_name' && this.toggle) {
      this.required = false;
      return [];
    }
    this.required = true;
    return [Validators.required];
  }
  onInputChange(event: Event, controlName: string) {
    if (controlName !== 'la_Dir' && controlName !== 'lo_Dir') {
      const inputElement = event.target as HTMLInputElement;
      const currentValue = inputElement.value;

      const numericValue = currentValue.replace(/[^.0-9 -]/g, '');

      inputElement.value = numericValue;
      this.portForm.get(controlName)?.setValue(numericValue);
    }

    if (
      controlName === 'la_Degree' ||
      controlName === 'la_Min' ||
      controlName === 'la_Dir' ||
      controlName === 'lo_Degree' ||
      controlName === 'lo_Min' ||
      controlName === 'lo_Dir'
    ) {
      this.convertToDecimalDegrees();
    }
  }
  convertToDecimalDegrees() {
    const laDegree = this.portForm.get('la_Degree')?.value;
    const laMin = this.portForm.get('la_Min')?.value;
    const laDir = this.portForm.get('la_Dir')?.value;

    const loDegree = this.portForm.get('lo_Degree')?.value;
    const loMin = this.portForm.get('lo_Min')?.value;
    const loDir = this.portForm.get('lo_Dir')?.value;

    const latDecimal = convertDMtoDD(laDegree, laMin, laDir);
    const lonDecimal = convertDMtoDD(loDegree, loMin, loDir);

    this.portForm.get('port_lat')?.setValue(latDecimal);
    this.portForm.get('port_lng')?.setValue(lonDecimal);
  }

  downloadClick() {
    this.formSubmitted = true;
    console.log(this.portForm.value);
    if (this.portForm.valid) {
      // this.dialog.open(PwThanksPageComponent, {
      //   width: '50%',
      //   height: '70%',
      // });
      this.toastr.success(ToasterMessages.SubmitForm);
    } else {
      this.toastr.info(ToasterMessages.FormValidation);
    }
  }
  emailClick() {
    this.formSubmitted = true;
    if (this.portForm.valid) {
      this.toastr.success(ToasterMessages.UnderDev);
    } else {
      this.toastr.info(ToasterMessages.ValidationError);
    }
  }
  filterSuggestions(value: any): void {
    const filterValue = value.toLowerCase();

    if (this.allPortData && value) {
      this.filteredPortNameSuggestions = this.allPortData.filter(
        (suggestion: any) =>
          suggestion.port_name.toLowerCase().startsWith(filterValue) ||
          suggestion.country.toLowerCase().startsWith(filterValue)
      );
      if (
        this.filteredPortNameSuggestions.length === 0 &&
        this.toggle === false
      ) {
        this.filteredPortNameSuggestions = [];
        this.portNameSelected = false;
      }
    } else {
      this.filteredPortNameSuggestions = [];
    }
  }
  onSelectPort(port: any): void {
    this.portForm.controls['port_lat'].setValue(port.latitude);
    this.portForm.controls['port_lng'].setValue(port.longitude);
    // const la = convertLatitudeDDtoDM(port.latitude);
    // const lo = convertLongitudeDDtoDM(port.longitude);
    this.portForm.controls['la_Degree'].setValue(port.lat_deg);
    this.portForm.controls['la_Min'].setValue(port.lat_min);
    this.portForm.controls['la_Dir'].setValue(port.lat_dir);
    this.portForm.controls['lo_Degree'].setValue(port.lng_deg);
    this.portForm.controls['lo_Min'].setValue(port.lng_min);
    this.portForm.controls['lo_Dir'].setValue(port.lng_dir);

    // console.log(la, lo);
    this.portNameSelected = true;
  }
  onToggleChange() {
    this.toggle = !this.toggle;

    const coordControls = ['la_Degree', 'la_Min', 'la_Dir', 'lo_Degree', 'lo_Min', 'lo_Dir'];

    if (this.toggle) {
      // Toggle OPENED: set formSubmitted = true to trigger all red validation errors
      this.formSubmitted = true;
      coordControls.forEach((controlName) => {
        const control = this.portForm.get(controlName);
        control?.setValidators([Validators.required]);
        control?.updateValueAndValidity();
        control?.markAsTouched();
      });
      // Port name becomes "At Sea" — no longer required
      const portNameControl = this.portForm.get('port_name');
      portNameControl?.clearValidators();
      portNameControl?.updateValueAndValidity();
      this.portForm.get('port_name')?.setValue('At Sea');
      this.portNameSelected = true;
      this.required = false;
    } else {
      // Toggle CLOSED: clear validation and reset state
      this.formSubmitted = false;
      coordControls.forEach((controlName) => {
        const control = this.portForm.get(controlName);
        control?.clearValidators();
        control?.updateValueAndValidity();
        control?.markAsUntouched();
        control?.markAsPristine();
      });
      const portNameControl = this.portForm.get('port_name');
      portNameControl?.setValidators([Validators.required]);
      portNameControl?.updateValueAndValidity();
      this.portForm.get('port_name')?.setValue('');
      this.portNameSelected = false;
      this.required = true;
    }
  }
  clearClick() {
    this.portForm.reset();
    this.formSubmitted = false;
    this.portNameSelected = false;
    if ((this.toggle = true)) this.onToggleChange();
    this.filteredPortNameSuggestions = [];
  }
  submitClick() {
    this.formSubmitted = true;
    let payload = {
      lat2: this.portForm.get('port_lat')?.value || '',
      lng2: this.portForm.get('port_lng')?.value || '',
      name: '',
      email: '',
      port_name: this.portForm.get('port_name')?.value || '',
      vessel_name: this.portForm.get('ship_name')?.value || '',
      day: this.portForm.get('days')?.value || '',
      hour_split: this.portForm.get('hours_split')?.value || '',
      report_date: this.portForm.get('start_date')?.value || '',
    };
    // console.log(payload, 'submid');
    this.validateTotalDays().subscribe((result) => {
      this.total = result;
      if (this.total > 10) {
        this.toastr.warning(ToasterMessages.FormValidation);
      } else {
        if (this.portForm.valid && this.portNameSelected) {
          this.portWeather
            .submitDetails(payload)
            .pipe(delay(1000))
            .subscribe(
              (data) => {
                this.button = true;
                if (data) {
                  // this.dialog.open(PwSubmitPopupComponent, {
                  //   width: '50%',
                  //   height: '70%',
                  // });
                  this.toastr.success(ToasterMessages.SubmitForm);
                  setTimeout(() => {
                    this.button = false;
                  }, 60000);

                  this.clearClick();
                }
              },
              (error) => {
                this.toastr.error(ToasterMessages.Error);
              }
            );
        } else if (!this.portNameSelected) {
          this.toastr.warning(ToasterMessages.FormValidation);
        } else {
          this.toastr.info(ToasterMessages.FormValidation);
        }
      }
    });
  }
  myRequestClick() {
    this.router.navigate(['/pw-myrequest']);
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
